import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { API } from '../api';
import Layout from '../components/Layout';

const STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Syne:wght@600;700;800&family=DM+Sans:wght@300;400;500;600&display=swap');
  @keyframes fadeSlideIn{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}
  @keyframes modalIn{from{opacity:0;transform:scale(0.94) translateY(16px)}to{opacity:1;transform:scale(1) translateY(0)}}
  @keyframes rowIn{from{opacity:0;transform:translateX(-10px)}to{opacity:1;transform:translateX(0)}}
  @keyframes spin{to{transform:rotate(360deg)}}
  @keyframes shimmer{0%{background-position:-600px 0}100%{background-position:600px 0}}
  @keyframes pulse{0%,100%{box-shadow:0 0 0 0 rgba(20,184,166,0.4)}50%{box-shadow:0 0 0 8px rgba(20,184,166,0)}}
  @keyframes slideUp{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}
  *{box-sizing:border-box}
  .is-root{font-family:'DM Sans',sans-serif;animation:fadeSlideIn 0.5s ease both}

  .is-input{width:100%;padding:13px 16px;background:#f0fdfa;border:1.5px solid #99f6e4;
    border-radius:12px;color:#1a1d2e;font-size:15px;font-family:'DM Sans',sans-serif;
    outline:none;transition:border-color 0.2s,box-shadow 0.2s,background 0.2s;
    text-align:center;font-weight:700;letter-spacing:1px}
  .is-input:focus{border-color:#14b8a6;background:#fff;box-shadow:0 0 0 3px rgba(20,184,166,0.15)}
  .is-input::placeholder{color:#a0aec0;font-weight:400;letter-spacing:0}
  .is-input:disabled{background:#f0f0f0;color:#a0aec0;cursor:not-allowed}

  .is-btn-primary{padding:13px 28px;background:linear-gradient(135deg,#2dd4bf,#14b8a6);
    border:none;border-radius:12px;color:#fff;font-size:14px;font-weight:700;
    font-family:'DM Sans',sans-serif;cursor:pointer;transition:transform 0.15s,box-shadow 0.15s;
    display:inline-flex;align-items:center;gap:8px;animation:pulse 2.5s ease-in-out infinite}
  .is-btn-primary:hover{transform:translateY(-2px);box-shadow:0 8px 24px rgba(20,184,166,0.4);animation:none}
  .is-btn-primary:disabled{opacity:0.6;cursor:not-allowed;animation:none;transform:none}
  .is-btn-secondary{padding:11px 22px;background:#f0fdfa;border:1.5px solid #99f6e4;
    border-radius:12px;color:#0f766e;font-size:14px;font-weight:600;
    font-family:'DM Sans',sans-serif;cursor:pointer;transition:all 0.15s}
  .is-btn-secondary:hover{background:#ccfbf1;border-color:#14b8a6}

  .is-row{animation:rowIn 0.35s ease both}
  .is-row:hover td{background:#f0fdfa !important;transition:background 0.15s}

  .action-btn{width:34px;height:34px;border:none;border-radius:9px;cursor:pointer;font-size:15px;
    display:inline-flex;align-items:center;justify-content:center;transition:transform 0.15s,box-shadow 0.15s}
  .action-btn:hover{transform:scale(1.18);box-shadow:0 4px 14px rgba(0,0,0,0.15)}

  .skeleton{background:linear-gradient(90deg,#f0fdfa 25%,#ccfbf1 50%,#f0fdfa 75%);
    background-size:600px 100%;animation:shimmer 1.5s infinite;border-radius:6px}

  .nav-item{display:flex;align-items:center;gap:12px;padding-top:11px;padding-bottom:11px;
    padding-left:16px;padding-right:16px;cursor:pointer;border-radius:10px;margin:2px 10px;
    color:#aaa;font-size:14px;transition:all 0.15s;white-space:nowrap}
  .nav-item:hover{background:rgba(255,255,255,0.05);color:#fff}
  .nav-item.active{background:rgba(20,184,166,0.15);color:#2dd4bf;border-left:3px solid #2dd4bf;padding-left:13px}

  .is-label{font-size:11px;font-weight:700;color:#0f766e;text-transform:uppercase;
    letter-spacing:0.5px;margin-bottom:6px;display:block}

  .badge{padding:4px 12px;border-radius:20px;font-size:12px;font-weight:600;display:inline-block}

  .toggle-wrap{display:flex;align-items:center;gap:10px;cursor:pointer;padding:8px 14px;
    border-radius:30px;border:1.5px solid #99f6e4;background:#f0fdfa;
    transition:all 0.2s;user-select:none}
  .toggle-wrap:hover{border-color:#14b8a6;background:#ccfbf1}
  .toggle-wrap.on{border-color:#14b8a6;background:#ccfbf1}
  .toggle-track{width:42px;height:22px;border-radius:11px;position:relative;
    transition:background 0.25s;flex-shrink:0}
  .toggle-thumb{position:absolute;width:16px;height:16px;border-radius:50%;background:#fff;
    top:3px;transition:left 0.25s;box-shadow:0 1px 4px rgba(0,0,0,0.2)}

  .slab-card{border-radius:14px;border:1.5px solid #ccfbf1;background:#fff;
    transition:all 0.2s;cursor:default;animation:slideUp 0.3s ease both}
  .slab-card:hover{border-color:#14b8a6;box-shadow:0 4px 16px rgba(20,184,166,0.12);transform:translateY(-2px)}
  .slab-card.editing{border-color:#14b8a6;box-shadow:0 0 0 3px rgba(20,184,166,0.15);background:#f0fdfa}
  .slab-card.latest{border-color:#f59e0b}

  .modal-scroll{overflow-y:auto;flex:1;padding:0 28px 20px}
  .modal-scroll::-webkit-scrollbar{width:5px}
  .modal-scroll::-webkit-scrollbar-thumb{background:#99f6e4;border-radius:3px}
`;


const EMPTY = { FromIns_slab:'', ToIns_slab:'', toMore:false };

export default function InsuranceDaySlab() {
  const navigate = useNavigate();
  const location = useLocation();

  const [authUser,  setAuthUser]  = useState(null);
  const [sideOpen,  setSideOpen]  = useState(true);
  const [slabs,     setSlabs]     = useState([]);
  const [nextFrom,  setNextFrom]  = useState(1);
  const [hasToMore, setHasToMore] = useState(false);
  const [loading,   setLoading]   = useState(true);
  const [form,      setForm]      = useState(EMPTY);
  const [editId,    setEditId]    = useState(null);
  const [saving,    setSaving]    = useState(false);
  const [delModal,  setDelModal]  = useState(null);
  const [delSaving, setDelSaving] = useState(false);
  const [page,      setPage]      = useState(1);
  const [toast,     setToast]     = useState(null);
  const PER = 12;

  useEffect(() => {
    if (!localStorage.getItem('token')) { navigate('/login'); return; }
    setAuthUser(JSON.parse(localStorage.getItem('user') || '{}'));
    fetchAll();
  }, []);

  const fetchAll = async () => {
    setLoading(true);
    try {
      const [r1, r2] = await Promise.all([
        API.get('/insurance-day-slab'),
        API.get('/insurance-day-slab/meta/nextfrom'),
      ]);
      setSlabs(r1.data);
      setNextFrom(r2.data.nextFrom);
      setHasToMore(r2.data.hasToMore);
      if (!editId) setForm(p => ({ ...p, FromIns_slab: r2.data.nextFrom || '' }));
    } catch(e) { showToast('Failed to load slabs', 'error'); }
    setLoading(false);
  };

  const showToast = (msg, type='success') => {
    setToast({msg, type});
    setTimeout(() => setToast(null), 3500);
  };

  const resetForm = useCallback((nf) => {
    setForm({ FromIns_slab: nf || nextFrom || '', ToIns_slab:'', toMore:false });
    setEditId(null);
  }, [nextFrom]);

  const startEdit = (slab) => {
    setEditId(slab.Insuranceslabid);
    setForm({
      FromIns_slab: slab.FromIns_slab,
      ToIns_slab:   slab.ToIns_slab === 1000 ? '' : slab.ToIns_slab,
      toMore:       slab.ToIns_slab === 1000,
    });
    window.scrollTo({top:0, behavior:'smooth'});
  };

  const handleSubmit = async () => {
    const from = parseInt(form.FromIns_slab);
    const to   = form.toMore ? 1000 : parseInt(form.ToIns_slab);

    if (!from || from < 1) { showToast('From Days is required', 'error'); return; }
    if (!form.toMore && (!form.ToIns_slab || to < from)) {
      showToast('To Days must be ≥ From Days', 'error'); return;
    }
    setSaving(true);
    try {
      const payload = { FromIns_slab: from, ToIns_slab: to, toMore: form.toMore };
      if (editId) {
        await API.put(`/insurance-day-slab/${editId}`, payload);
        showToast('Insurance day slab updated ✓');
      } else {
        await API.post('/insurance-day-slab', payload);
        showToast('Insurance day slab added ✓');
      }
      await fetchAll();
      resetForm();
    } catch(e) {
      showToast(e.response?.data?.message || 'Operation failed', 'error');
    }
    setSaving(false);
  };

  const handleDelete = async () => {
    setDelSaving(true);
    try {
      await API.delete(`/insurance-day-slab/${delModal.Insuranceslabid}`);
      showToast('Insurance day slab deleted ✓');
      setDelModal(null);
      if (editId === delModal.Insuranceslabid) resetForm();
      await fetchAll();
    } catch(e) {
      showToast(e.response?.data?.message || 'Delete failed', 'error');
    }
    setDelSaving(false);
  };

  const formatRange = (s) =>
    s.ToIns_slab === 1000
      ? `${s.FromIns_slab} Days & Above`
      : `${s.FromIns_slab} – ${s.ToIns_slab} Days`;

  const daysBetween = (a, b) => b && a ? Math.abs(b - a) + 1 : null;

  const totalPages = Math.ceil(slabs.length / PER);
  const paged      = slabs.slice((page-1)*PER, page*PER);
  const maxId      = slabs.length ? Math.max(...slabs.map(s=>s.Insuranceslabid)) : null;
  const logout     = () => { localStorage.clear(); navigate('/login'); };

  // Coverage stats
  const totalDays  = slabs.reduce((acc, s) => {
    if (s.ToIns_slab === 1000) return acc;
    return acc + (s.ToIns_slab - s.FromIns_slab + 1);
  }, 0);
  const hasUnlimited = slabs.some(s => s.ToIns_slab === 1000);

  return (
    <Layout activePage="Optional Extra Details">
    <>
      <style>{STYLES}</style>
      <div style={S.root} className="is-root">

        {/* ── Sidebar ── */}
        {/* <aside style={{...S.sidebar, width: sideOpen?220:68}}>
          <div style={S.sideTop}>
            <div style={S.logoWrap}>
              <div style={S.logoIcon}>🚗</div>
              {sideOpen && <span style={S.logoText}>Orisys</span>}
            </div>
            <button style={S.collapseBtn} onClick={()=>setSideOpen(p=>!p)}>
              {sideOpen?'◀':'▶'}
            </button>
          </div>
          <nav style={{flex:1}}>
            {NAV.map(n=>(
              <div key={n.label}
                className={`nav-item${location.pathname===n.path?' active':''}`}
                onClick={()=>navigate(n.path)}>
                <span style={{fontSize:16,flexShrink:0}}>{n.icon}</span>
                {sideOpen && <span style={{fontWeight:500}}>{n.label}</span>}
              </div>
            ))}
          </nav>
          <div style={S.sideBottom}>
            {sideOpen && (
              <div style={S.userChip}>
                <div style={S.avatar}>{authUser?.user_name?.[0]||'A'}</div>
                <div>
                  <div style={S.uname}>{authUser?.user_name||'Admin'}</div>
                  <div style={S.urole}>Administrator</div>
                </div>
              </div>
            )}
            <button style={S.logoutBtn} onClick={logout}>
              <span>🚪</span>{sideOpen&&<span style={{marginLeft:8}}>Logout</span>}
            </button>
          </div>
        </aside> */}

        {/* ── Main ── */}
        <main>

          {/* Header */}
          <div style={S.pageHeader}>
            <div>
              <h1 style={S.pageTitle}>Insurance Day Slab</h1>
              <p style={S.pageSub}>Configure insurance day ranges for pricing tiers</p>
            </div>
            <div style={{display:'flex',gap:12,flexWrap:'wrap'}}>
              {[
                {label:'Total Slabs',  value:slabs.length,      color:'#0f766e', bg:'#f0fdfa', icon:'🛡️'},
                {label:'Days Covered', value:hasUnlimited?'∞':totalDays, color:'#0891b2', bg:'#ecfeff', icon:'📅'},
                {label:'Open-Ended',   value:hasUnlimited?'Yes':'No', color:'#7c3aed', bg:'#f5f3ff', icon:'♾️'},
              ].map(s=>(
                <div key={s.label} style={{...S.miniStat,background:s.bg}}>
                  <span style={{fontSize:22}}>{s.icon}</span>
                  <div>
                    <div style={{fontSize:22,fontWeight:800,color:s.color,lineHeight:1}}>{s.value}</div>
                    <div style={{fontSize:10,color:'#718096',fontWeight:600,textTransform:'uppercase'}}>{s.label}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* ── Add / Edit Form ── */}
          <div style={S.formCard}>
            <div style={S.formCardHead}>
              <div style={S.formCardIcon}>{editId?'✏️':'🛡️'}</div>
              <div style={{flex:1}}>
                <h2 style={S.formCardTitle}>
                  {editId ? 'Edit Insurance Day Slab' : 'Add Insurance Day Slab'}
                </h2>
                <p style={S.formCardSub}>
                  {editId
                    ? `Editing Slab #${editId}`
                    : hasToMore
                      ? 'An open-ended slab already exists. Delete the highest slab first.'
                      : `Next From value starts at Day ${nextFrom}`}
                </p>
              </div>
              {editId && (
                <button className="is-btn-secondary" onClick={()=>resetForm()}>✕ Cancel Edit</button>
              )}
            </div>

            {hasToMore && !editId ? (
              <div style={S.warningBox}>
                ⚠️ An <strong>open-ended "To More Days"</strong> slab already exists.
                Delete the highest slab first before adding a new one.
              </div>
            ) : (
              <>
                {/* Form row */}
                <div style={S.formRow}>
                  {/* From Days */}
                  <div style={S.fieldBox}>
                    <label className="is-label">FROM — Day *</label>
                    <input className="is-input" type="number" min="1" max="9999"
                      placeholder="e.g. 1"
                      value={form.FromIns_slab}
                      onChange={e=>setForm(p=>({...p,FromIns_slab:e.target.value}))}
                      style={{borderColor:'#14b8a6',background:'#ccfbf1'}}/>
                    <div style={S.fieldHint}>Starting day of insurance slab</div>
                  </div>

                  {/* Arrow */}
                  <div style={S.arrow}>→</div>

                  {/* To Days */}
                  <div style={S.fieldBox}>
                    <label className="is-label">TO — Day *</label>
                    <input className="is-input" type="number" min="1" max="9999"
                      placeholder={form.toMore?'∞ Unlimited':'e.g. 30'}
                      value={form.toMore ? '' : form.ToIns_slab}
                      disabled={form.toMore}
                      onChange={e=>setForm(p=>({...p,ToIns_slab:e.target.value}))}
                      style={form.toMore?{borderColor:'#a0aec0',background:'#f0f0f0',color:'#a0aec0'}:{}}/>
                    <div style={S.fieldHint}>
                      {form.FromIns_slab && form.ToIns_slab && !form.toMore
                        ? `${daysBetween(parseInt(form.FromIns_slab),parseInt(form.ToIns_slab))} day(s) span`
                        : 'Ending day of insurance slab'}
                    </div>
                  </div>

                  {/* Open-ended toggle */}
                  <div style={S.fieldBox}>
                    <label className="is-label">OPEN-ENDED</label>
                    <div className={`toggle-wrap${form.toMore?' on':''}`}
                      onClick={()=>setForm(p=>({...p,toMore:!p.toMore,ToIns_slab:''}))}>
                      <div className="toggle-track"
                        style={{background:form.toMore?'#14b8a6':'#e2e8f0'}}>
                        <div className="toggle-thumb"
                          style={{left:form.toMore?'22px':'4px'}}/>
                      </div>
                      <span style={{fontSize:13,fontWeight:600,
                        color:form.toMore?'#0f766e':'#718096'}}>
                        {form.toMore?'✓ To More Days (∞)':'Set specific days'}
                      </span>
                    </div>
                    <div style={S.fieldHint}>Enable for unlimited upper range</div>
                  </div>

                  {/* Submit */}
                  <div style={{...S.fieldBox,justifyContent:'flex-end'}}>
                    <label className="is-label">&nbsp;</label>
                    <button className="is-btn-primary" onClick={handleSubmit} disabled={saving}>
                      {saving
                        ? <span style={S.spinner}/>
                        : editId ? '💾 Update Slab' : '＋ Add Slab'}
                    </button>
                    {editId && (
                      <button className="is-btn-secondary" style={{marginTop:8}}
                        onClick={()=>resetForm()}>Clear</button>
                    )}
                  </div>
                </div>

                {/* Live preview */}
                {form.FromIns_slab && (form.ToIns_slab || form.toMore) && (
                  <div style={S.previewBox}>
                    <span style={{fontSize:13,fontWeight:700,color:'#0f766e'}}>📋 Preview: </span>
                    <span style={{fontSize:15,fontWeight:800,color:'#14b8a6'}}>
                      {form.toMore
                        ? `Day ${form.FromIns_slab} & Above (Open-Ended)`
                        : `Day ${form.FromIns_slab} – Day ${form.ToIns_slab}`}
                    </span>
                    {!form.toMore && form.FromIns_slab && form.ToIns_slab && (
                      <span style={{fontSize:12,color:'#a0aec0',marginLeft:12}}>
                        {daysBetween(parseInt(form.FromIns_slab),parseInt(form.ToIns_slab))} day(s)
                      </span>
                    )}
                  </div>
                )}
              </>
            )}
          </div>

          {/* ── Slab List ── */}
          <div style={S.tableCard}>
            <div style={S.tableCardHead}>
              <h3 style={S.tableCardTitle}>📋 Manage Insurance Day Slabs</h3>
              <span style={{fontSize:12,background:'#ccfbf1',color:'#0f766e',
                borderRadius:20,padding:'4px 14px',fontWeight:700}}>
                {slabs.length} slab{slabs.length!==1?'s':''}
              </span>
            </div>

            {/* Visual timeline */}
            {!loading && slabs.length > 0 && (
              <div style={{padding:'16px 24px 0',display:'flex',alignItems:'center',
                gap:0,overflowX:'auto',paddingBottom:16}}>
                {[...slabs].reverse().map((s,i)=>{
                  const isToMore = s.ToIns_slab === 1000;
                  const colors   = ['#14b8a6','#0891b2','#7c3aed','#f59e0b','#ef4444','#22c55e'];
                  const col      = colors[i % colors.length];
                  return (
                    <React.Fragment key={s.Insuranceslabid}>
                      {i>0 && <div style={{width:20,height:2,background:'#e2e8f0',flexShrink:0}}/>}
                      <div style={{flexShrink:0,textAlign:'center',minWidth:90,
                        padding:'8px 12px',borderRadius:12,border:`2px solid ${col}`,
                        background:`${col}15`,cursor:'pointer',
                        outline:editId===s.Insuranceslabid?`3px solid ${col}`:'none'}}
                        onClick={()=>startEdit(s)}>
                        <div style={{fontSize:12,fontWeight:800,color:col}}>
                          {isToMore?`${s.FromIns_slab}+`:`${s.FromIns_slab}-${s.ToIns_slab}`}
                        </div>
                        <div style={{fontSize:10,color:'#a0aec0',marginTop:2}}>
                          {isToMore?'∞':'days'}
                        </div>
                      </div>
                    </React.Fragment>
                  );
                })}
              </div>
            )}

            {/* Table */}
            <div style={{overflowX:'auto'}}>
              <table style={S.table}>
                <thead>
                  <tr style={{background:'linear-gradient(135deg,#f0fdfa,#ccfbf1)'}}>
                    {['#','Insurance Day Slab','From Day','To Day','Span','Type','Actions'].map(h=>(
                      <th key={h} style={S.th}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {loading
                    ? Array.from({length:5}).map((_,i)=>(
                        <tr key={i}>{Array.from({length:7}).map((_,j)=>(
                          <td key={j} style={S.td}>
                            <div className="skeleton" style={{height:14,width:'70%'}}/>
                          </td>
                        ))}</tr>
                      ))
                    : paged.length===0
                    ? (
                        <tr>
                          <td colSpan={7} style={{textAlign:'center',padding:'48px 0',color:'#a0aec0'}}>
                            <div style={{fontSize:40,marginBottom:10}}>🛡️</div>
                            <div style={{fontSize:15,fontWeight:600}}>No insurance day slabs yet</div>
                            <div style={{fontSize:13,marginTop:4}}>Use the form above to add your first slab</div>
                          </td>
                        </tr>
                      )
                    : paged.map((s,i)=>{
                        const isToMore = s.ToIns_slab === 1000;
                        const isMax    = s.Insuranceslabid === maxId;
                        const span     = isToMore ? '∞' : daysBetween(s.FromIns_slab, s.ToIns_slab);
                        return (
                          <tr key={s.Insuranceslabid} className="is-row"
                            style={{borderBottom:'1px solid #f0fdfa',
                              background:editId===s.Insuranceslabid?'#f0fdfa':i%2===0?'#fff':'#fafffe'}}>
                            <td style={{...S.td,color:'#a0aec0',fontWeight:700,fontSize:12}}>
                              {(page-1)*PER+i+1}
                            </td>
                            <td style={S.td}>
                              <div style={{display:'flex',alignItems:'center',gap:12}}>
                                <div style={{width:40,height:40,borderRadius:10,flexShrink:0,
                                  background:isToMore
                                    ?'linear-gradient(135deg,#a78bfa,#7c3aed)'
                                    :'linear-gradient(135deg,#2dd4bf,#14b8a6)',
                                  display:'flex',alignItems:'center',justifyContent:'center',
                                  fontSize:18}}>
                                  {isToMore?'♾️':'🛡️'}
                                </div>
                                <div>
                                  <div style={{fontWeight:700,fontSize:14,color:'#1a1d2e'}}>
                                    {formatRange(s)}
                                  </div>
                                  {isMax && (
                                    <span style={{fontSize:10,background:'#fef9c3',color:'#854d0e',
                                      padding:'1px 6px',borderRadius:10,fontWeight:700}}>
                                      LATEST · Deletable
                                    </span>
                                  )}
                                  {editId===s.Insuranceslabid && (
                                    <span style={{fontSize:10,background:'#ccfbf1',color:'#0f766e',
                                      padding:'1px 6px',borderRadius:10,fontWeight:700,marginLeft:4}}>
                                      EDITING
                                    </span>
                                  )}
                                </div>
                              </div>
                            </td>
                            <td style={S.td}>
                              <span className="badge" style={{background:'#ccfbf1',color:'#0f766e'}}>
                                Day {s.FromIns_slab}
                              </span>
                            </td>
                            <td style={S.td}>
                              <span className="badge"
                                style={isToMore
                                  ?{background:'#f3e8ff',color:'#7e22ce'}
                                  :{background:'#f0fdf4',color:'#166534'}}>
                                {isToMore?'∞ No Limit':`Day ${s.ToIns_slab}`}
                              </span>
                            </td>
                            <td style={S.td}>
                              <span style={{fontWeight:700,color:'#0891b2',fontSize:13}}>
                                {span}{typeof span==='number'?' days':''}
                              </span>
                            </td>
                            <td style={S.td}>
                              <span className="badge"
                                style={isToMore
                                  ?{background:'#f5f3ff',color:'#6d28d9',border:'1.5px solid #ddd6fe'}
                                  :{background:'#ecfeff',color:'#0e7490',border:'1.5px solid #a5f3fc'}}>
                                {isToMore?'♾️ Open-Ended':'📅 Fixed Range'}
                              </span>
                            </td>
                            <td style={S.td}>
                              <div style={{display:'flex',gap:6,alignItems:'center'}}>
                                <button className="action-btn"
                                  style={{background:'#fefcbf',color:'#744210'}}
                                  title="Edit" onClick={()=>startEdit(s)}>✏️</button>
                                <button className="action-btn"
                                  style={{
                                    background:isMax?'#fff5f5':'#f0f0f0',
                                    color:isMax?'#c53030':'#a0aec0',
                                    cursor:isMax?'pointer':'not-allowed',
                                    opacity:isMax?1:0.45
                                  }}
                                  title={isMax?'Delete this slab':'Delete the latest slab first'}
                                  onClick={()=>isMax&&setDelModal(s)}>🗑</button>
                                {!isMax && (
                                  <span style={{fontSize:10,color:'#a0aec0',whiteSpace:'nowrap'}}>
                                    Not deletable
                                  </span>
                                )}
                              </div>
                            </td>
                          </tr>
                        );
                      })
                  }
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div style={S.pagination}>
                <span style={{fontSize:13,color:'#718096'}}>
                  Showing {(page-1)*PER+1}–{Math.min(page*PER,slabs.length)} of {slabs.length}
                </span>
                <div style={{display:'flex',gap:6}}>
                  <button style={S.pageBtn} disabled={page===1} onClick={()=>setPage(p=>p-1)}>← Prev</button>
                  {Array.from({length:totalPages},(_,i)=>i+1).map(p=>(
                    <button key={p} style={{...S.pageBtn,...(p===page?S.pageBtnActive:{})}}
                      onClick={()=>setPage(p)}>{p}</button>
                  ))}
                  <button style={S.pageBtn} disabled={page===totalPages} onClick={()=>setPage(p=>p+1)}>Next →</button>
                </div>
              </div>
            )}
          </div>

          {/* Info box */}
          <div style={S.infoBox}>
            <div style={{fontSize:22,marginBottom:6}}>💡</div>
            <div>
              <strong style={{color:'#0f766e'}}>How Insurance Day Slabs Work</strong>
              <p style={{fontSize:13,color:'#4a5568',margin:'6px 0 0',lineHeight:1.6}}>
                Slabs define insurance pricing tiers based on rental duration.
                For example: <strong>1–7 days</strong>, <strong>8–30 days</strong>, <strong>31+ days</strong>.
                Only the <strong>latest slab</strong> (highest ID) can be deleted to maintain data integrity.
                Use <strong>To More Days</strong> for an open-ended upper limit.
              </p>
            </div>
          </div>
        </main>

        {/* ── Delete Modal ── */}
        {delModal && (
          <div style={S.overlay} onClick={()=>setDelModal(null)}>
            <div style={{...S.modal,maxWidth:420}} onClick={e=>e.stopPropagation()}>
              <div style={{padding:'36px 32px',textAlign:'center'}}>
                <div style={{fontSize:52,marginBottom:16}}>🗑️</div>
                <h2 style={{fontSize:20,fontWeight:800,color:'#1a1d2e',marginBottom:8}}>Delete Slab?</h2>
                <div style={{marginBottom:16}}>
                  <span className="badge" style={{background:'#ccfbf1',color:'#0f766e',fontSize:15,padding:'6px 16px'}}>
                    🛡️ {formatRange(delModal)}
                  </span>
                </div>
                <p style={{color:'#718096',fontSize:14,lineHeight:1.7,marginBottom:28}}>
                  This will also remove any related inner slab records.<br/>
                  <strong style={{color:'#e53e3e'}}>This action cannot be undone.</strong>
                </p>
                <div style={{display:'flex',gap:12,justifyContent:'center'}}>
                  <button className="is-btn-secondary" onClick={()=>setDelModal(null)}>Cancel</button>
                  <button disabled={delSaving} onClick={handleDelete} style={{
                    padding:'12px 24px',background:'linear-gradient(135deg,#fc8181,#e53e3e)',
                    border:'none',borderRadius:12,color:'#fff',fontWeight:700,fontSize:14,
                    fontFamily:'DM Sans,sans-serif',cursor:'pointer',
                    display:'flex',alignItems:'center',gap:8}}>
                    {delSaving?<span style={S.spinner}/>:'🗑️ Delete Permanently'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* ── Toast ── */}
        {toast && (
          <div style={{...S.toast,
            background:toast.type==='error'?'#fff5f5':'#f0fdfa',
            borderColor:toast.type==='error'?'#fc8181':'#2dd4bf',
            color:toast.type==='error'?'#c53030':'#0f766e'}}>
            {toast.type==='error'?'⚠️':'✅'} {toast.msg}
          </div>
        )}
      </div>
    </>
    </Layout>
  );
}

/* ─── Styles ─── */
const S = {
  root:{display:'flex',minHeight:'100vh',background:'#f7fefc'},
  
  main:{flex:1,padding:'28px',minWidth:0},
  pageHeader:{display:'flex',justifyContent:'space-between',alignItems:'flex-start',
    marginBottom:24,flexWrap:'wrap',gap:16},
  pageTitle:{fontSize:26,fontWeight:800,color:'#1a1d2e',letterSpacing:'-0.5px',margin:0,
    fontFamily:"'Syne',sans-serif"},
  pageSub:{fontSize:13,color:'#a0aec0',margin:'4px 0 0'},
  miniStat:{display:'flex',alignItems:'center',gap:12,borderRadius:14,padding:'14px 18px',
    boxShadow:'0 2px 10px rgba(0,0,0,0.05)'},

  formCard:{background:'#fff',borderRadius:20,padding:'28px',
    boxShadow:'0 4px 24px rgba(20,184,166,0.08)',marginBottom:24,border:'1.5px solid #99f6e4'},
  formCardHead:{display:'flex',alignItems:'flex-start',gap:16,marginBottom:22},
  formCardIcon:{width:48,height:48,background:'linear-gradient(135deg,#2dd4bf,#14b8a6)',
    borderRadius:14,display:'flex',alignItems:'center',justifyContent:'center',
    fontSize:22,flexShrink:0,boxShadow:'0 4px 14px rgba(20,184,166,0.35)'},
  formCardTitle:{fontSize:18,fontWeight:800,color:'#1a1d2e',margin:0,fontFamily:"'Syne',sans-serif"},
  formCardSub:{fontSize:13,color:'#a0aec0',margin:'4px 0 0'},

  formRow:{display:'grid',gridTemplateColumns:'1fr 44px 1fr 1fr 160px',gap:16,alignItems:'start'},
  fieldBox:{display:'flex',flexDirection:'column',gap:6},
  fieldHint:{fontSize:11,color:'#a0aec0'},
  arrow:{display:'flex',alignItems:'center',justifyContent:'center',paddingTop:36,
    fontSize:22,color:'#14b8a6',fontWeight:700},
  warningBox:{background:'#fffbeb',border:'1.5px solid #f6e05e',borderRadius:12,
    padding:'16px 20px',color:'#744210',fontSize:14,lineHeight:1.6},
  previewBox:{marginTop:16,background:'linear-gradient(135deg,#f0fdfa,#ccfbf1)',
    borderRadius:12,padding:'14px 18px',border:'1.5px solid #99f6e4',
    display:'flex',alignItems:'center',gap:8},

  tableCard:{background:'#fff',borderRadius:20,overflow:'hidden',
    boxShadow:'0 4px 24px rgba(20,184,166,0.08)',marginBottom:20,border:'1.5px solid #99f6e4'},
  tableCardHead:{display:'flex',justifyContent:'space-between',alignItems:'center',
    padding:'20px 24px',borderBottom:'1px solid #f0fdfa'},
  tableCardTitle:{fontSize:16,fontWeight:800,color:'#1a1d2e',margin:0,fontFamily:"'Syne',sans-serif"},
  table:{width:'100%',borderCollapse:'collapse'},
  th:{padding:'14px 18px',fontSize:11,fontWeight:700,color:'#0f766e',textAlign:'left',
    textTransform:'uppercase',letterSpacing:'0.5px',borderBottom:'2px solid #ccfbf1'},
  td:{padding:'14px 18px',fontSize:13,color:'#4a5568',verticalAlign:'middle'},

  pagination:{display:'flex',justifyContent:'space-between',alignItems:'center',
    padding:'16px 24px',borderTop:'1px solid #f0fdfa'},
  pageBtn:{padding:'6px 12px',border:'1.5px solid #99f6e4',borderRadius:8,background:'#fff',
    color:'#0f766e',fontSize:13,fontWeight:600,cursor:'pointer',
    fontFamily:'DM Sans,sans-serif',transition:'all 0.15s'},
  pageBtnActive:{background:'#14b8a6',borderColor:'#14b8a6',color:'#fff'},

  infoBox:{background:'linear-gradient(135deg,#f0fdfa,#ecfeff)',borderRadius:16,
    padding:'20px 24px',border:'1.5px solid #99f6e4',display:'flex',gap:16,alignItems:'flex-start'},

  overlay:{position:'fixed',inset:0,background:'rgba(5,20,15,0.6)',zIndex:200,
    display:'flex',alignItems:'center',justifyContent:'center',backdropFilter:'blur(4px)',padding:'20px'},
  modal:{background:'#fff',borderRadius:20,width:'100%',maxWidth:620,
    boxShadow:'0 32px 80px rgba(20,184,166,0.2)',animation:'modalIn 0.3s ease both'},
  spinner:{display:'inline-block',width:16,height:16,border:'2px solid rgba(255,255,255,0.3)',
    borderTopColor:'#fff',borderRadius:'50%',animation:'spin 0.6s linear infinite'},
  toast:{position:'fixed',bottom:28,right:28,zIndex:999,padding:'14px 22px',
    borderRadius:12,border:'1.5px solid',fontSize:14,fontWeight:600,
    fontFamily:'DM Sans,sans-serif',boxShadow:'0 8px 24px rgba(0,0,0,0.12)',
    animation:'fadeSlideIn 0.3s ease'},
};